import { type FC, type ComponentProps, lazy, Suspense } from 'react';

const BuyerIncentivesBannerExtended = lazy(
    () =>
        import(
            /* webpackChunkName: "BuyerIncentivesBannerExtended" */ './BuyerIncentivesBannerExtended.tsx'
        )
);

export const BuyerIncentivesBannerExtendedLazy: FC<
    ComponentProps<typeof BuyerIncentivesBannerExtended>
> = props => (
    <Suspense fallback={null}>
        <BuyerIncentivesBannerExtended {...props} />
    </Suspense>
);
